import { render } from "./PlantListPage.vue?vue&type=template&id=6fb1b3e4&ts=true"
import script from "./PlantListPage.vue?vue&type=script&lang=ts"
export * from "./PlantListPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/voquanghoa/code/medicinal-plant/MedicinalPlant.Frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/PlantListPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fb1b3e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fb1b3e4', __exports__)) {
    api.reload('6fb1b3e4', __exports__)
  }
  
  module.hot.accept("./PlantListPage.vue?vue&type=template&id=6fb1b3e4&ts=true", () => {
    api.rerender('6fb1b3e4', render)
  })

}


export default __exports__